import { useEffect } from "react";
import SearchPane from "../Components/Homepage/SearchPane";
import LeftBar from "../Components/Homepage/LeftBar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { LogInURL } from "../Variables/variable";


function HomePage() {
    let location = useLocation();
    const currentPathname = location.pathname;

    let navigate = useNavigate();
    useEffect(() => {
        const isLoggedIn = localStorage.getItem('token');
        if((!isLoggedIn || isLoggedIn==='false')){
            console.log('log out')
            window.location.href = LogInURL;
        }
        else{
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.setItem('access_token', localStorage.getItem("token"));
        }
    }, [navigate])
    
    window.addEventListener('storage', function(e){
        // console.log(e)
        const isLoggedIn = localStorage.getItem("token");
        if((!isLoggedIn || isLoggedIn==='false')){
            window.location.href = LogInURL;
        }
        else{
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.setItem('access_token', localStorage.getItem("token"));
        }
    })  

    return(
        <div className="h-screen">
            <LeftBar leftBarList={["addPatient", "addRecord", "testRecord", "questions"]}></LeftBar>
            <div className="flex-wrap block w-full">
                { currentPathname==="/home/basic_info" || currentPathname==="/home/test_record" || currentPathname==="/home/add_record"?  <SearchPane></SearchPane> : <></>}
                <Outlet></Outlet>
            </div>
        </div>
        
    )
}

export default HomePage;